module.exports = __webpack_public_path__ + "pl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pl.svg
// module id = 759
// module chunks = 0